"use strict";

const IndComSettings = function () {
  const stringKey = "indcom-settings";
  const tabHeader = "IndCom";

  var _onImportHistoricInspectionsClick = function () {
    $("#assessment-modal").find(".historic-inspections-csv-input").trigger("click");
  };

  var _onImportHistoricInspectionsFileChange = async function (e) {
    const csvFile = e.target.files[0];
    e.target.value = "";

    if (!csvFile) {
      return;
    }

    const groupId = Tree.get("activeGroup", "groupId");

    try {
      const result = await ApiCalls.importHistoricFacilityInspections(groupId, csvFile);
      MessageModal.showSimpleWarningModal(
        `Imported ${result.numCreated} historic inspection${result.numCreated === 1 ? "" : "s"}.`,
      );
    } catch (error) {
      UploadValidator.reportError(error);
    }
  };

  var loadListeners = function (data) {
    UserVariableValidator.init(
      Object.keys(data.indcom?.maintenanceNoticeUserTemplate || {}),
      ".validate-indcom-maintenance-notice-variables",
    );
    $("#assessment-modal").on(
      "click",
      ".import-historic-inspections-button",
      _onImportHistoricInspectionsClick,
    );
    $("#assessment-modal").on(
      "change",
      ".historic-inspections-csv-input",
      _onImportHistoricInspectionsFileChange,
    );
  };

  var unloadListeners = function () {
    $("#assessment-modal").off(
      "click",
      ".import-historic-inspections-button",
      _onImportHistoricInspectionsClick,
    );
    $("#assessment-modal").off(
      "change",
      ".historic-inspections-csv-input",
      _onImportHistoricInspectionsFileChange,
    );
  };

  var getProps = function (data) {
    return {};
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
  };
};

module.exports = IndComSettings();

const ApiCalls = require("../../apiCalls");
const MessageModal = require("../../modals/messageModal");
const Tree = require("../../tree");
const UploadValidator = require("../../general/uploadValidator");
const UserVariableValidator = require("../../misc/userVariableValidator");
